"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectableSource = void 0;
const IProduceValueEvents_1 = require("./IProduceValueEvents");
const ListenerCollection_1 = require("./ListenerCollection");
class InjectableSource {
    constructor(eventSource) {
        this.listenerCollection = new ListenerCollection_1.ListenerCollection();
        eventSource.registerValueEventListener((status, error, value) => {
            this.invokeRegisteredListeners(status, error, value);
        });
    }
    inject(value, status = IProduceValueEvents_1.ValueStatus.Ok, error = null) {
        this.invokeRegisteredListeners(status, error, value);
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
    invokeRegisteredListeners(status, error, value) {
        this.listenerCollection.invoke(status, error, value);
    }
}
exports.InjectableSource = InjectableSource;
//# sourceMappingURL=InjectableSource.js.map